module.exports = __webpack_public_path__ + "media/images/locations/circle/canada-cc10faf95ce9a58a61ca246d632b2ddc.jpg";